import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import './ContentPolicyModal.css';

// Warning dialog when LED text fails local EN/HI content policy check
const ContentPolicyModal = ({ isOpen, onClose, matches = [] }) => {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }

    return () => {
      document.body.style.overflow = '';
    };
  }, [isOpen]);

  if (!isOpen) {
    return null;
  }

  return (
    <div className="content-policy-modal-overlay" onClick={onClose}>
      <div
        className="content-policy-modal-container"
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-labelledby="content-policy-modal-title"
      >
        <button
          type="button"
          className="content-policy-modal-close"
          onClick={onClose}
          aria-label="Close"
        >
          ×
        </button>

        <h2 id="content-policy-modal-title" className="content-policy-modal-title">
          Content not allowed
        </h2>

        <p className="content-policy-modal-body">
          Your text includes language that is not allowed under our Acceptable Use Policy
          (NSFW, abusive, or other prohibited content). Please remove the flagged words and
          try again.
        </p>

        {/* {matches.length > 0 && (
          <div className="content-policy-modal-matches">
            <p className="content-policy-modal-matches-label">Flagged words</p>
            <ul className="content-policy-modal-matches-list">
              {matches.map((word) => (
                <li key={word}>{word}</li>
              ))}
            </ul>
          </div>
        )} */}

        <p className="content-policy-modal-link-row">
          See{' '}
          <Link to="/terms" className="content-policy-modal-link" onClick={onClose}>
            Terms — Acceptable Use
          </Link>
          .
        </p>

        <div className="content-policy-modal-actions">
          <button
            type="button"
            className="content-policy-modal-btn content-policy-modal-btn-primary"
            onClick={onClose}
          >
            Edit text
          </button>
        </div>
      </div>
    </div>
  );
};

export default ContentPolicyModal;
